polyline{stroke:#e31c3d;pointer-events:none;stroke-width:var(--h3-screen-pixel-width)}
/*# sourceMappingURL=hair.component.css.map */
